export default __webpack_public_path__ + "static/media/jingdong2.3582c030.jpg";